import React, { useEffect, useState } from "react";
import { Card, Statistic, Typography, DatePicker, Input } from "antd";
import { Row, Col } from "react-bootstrap";
import LeadsTable from "../components/Leads/LeadsTable";
import { connect } from "react-redux";
import { getAllBusinessCards } from "../store/action/business/DashboardActions";
import { getThisWeekLeadBusiness } from "../store/action/business/LeadAction";
import { PiDotsThreeBold } from "react-icons/pi";
import Avatar from "@mui/material/Avatar";
import { MdOutlinePeople } from "react-icons/md";
import { SearchOutlined } from "@ant-design/icons";
import WeeklyChartBusiness from "../components/Charts/WeeklyChartBusiness";
import { GoStack } from "react-icons/go";
import ChangePasswordModal from "../components/Modals/ChangePasswordModal";
import { baseURL } from "../store/api/axios";
import { encryptdata } from "../utils/encryptDecrypt";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const LeadGenerationAnalytics = (props) => {
  const { Title, Text } = Typography;
  const [totalAmt, setTotalAmt] = useState(10);
  const [totalLeads, setTotalLeads] = useState(10);
  const [avergeAmount, setAvergeAmount] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [leads, setLeads] = useState([]);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    props.getAllBusinessCards_();
    props.getThisWeekLeads_();
  }, []);

  useEffect(() => {
    setTotalAmt(props.businessCard.totalAmount);
    setTotalLeads(props.businessCard.totalDistributedLeads);
  }, [props.businessCard]);

  useEffect(() => {
    if (
      props.thisWeekLeadBusiness &&
      props.thisWeekLeadBusiness.leads &&
      props.thisWeekLeadBusiness.leads.length > 0
    )
      setLeads(props.thisWeekLeadBusiness.leads);
  }, [props.thisWeekLeadBusiness]);

  const firstLogin = localStorage.getItem("firstLogin") === "true";

  const fetchAvergeAmount = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      const response = await fetch(`${baseURL}txn/transactions/average`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });
      const result = await response.json();
      setAvergeAmount(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAvergeAmount();
  }, []);

  const filteredData = Array.isArray(avergeAmount)
    ? avergeAmount.filter(
        (averge) =>
          searchTerm.trim() === "" ||
          averge?.companyName
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          averge?.highestTransaction
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()),
      )
    : [];

  const country = localStorage.getItem("country") || "";

  const getSymbol = (country) => {
    if (country === "United Kingdom") return "£";
    if (country === "India") return "₹";
    if (country === "Canada") return "CA$";
    return "";
  };

  return (
    <div style={{ padding: isMobile ? 12 : 20 }}>
      {firstLogin && <ChangePasswordModal />}
      <Title level={isMobile ? 4 : 2}>Dashboard</Title>

      <Row style={{ width: "100%" }}>
        <Col xs={12} md={8}>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Card
                title="Total Credits Spend"
                extra={
                  <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
                }
                style={{ width: "100%" }}
              >
                <div style={{ marginBottom: "20px" }}>
                  {/* <DatePicker /> */}
                </div>
                <h3>
                  <GoStack style={{ marginBottom: "5px", fontSize: "25px" }} />{" "}
                  {totalAmt}
                </h3>
              </Card>
            </Col>
            <Col xs={12}  md={6}>
              <Card
                title="Total Leads Generated"
                extra={
                  <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
                }
                style={{ width: "100%" }}
              >
                <div style={{ marginBottom: "20px" }}>
                  {/* <DatePicker /> */}
                </div>
                <h3>
                  <MdOutlinePeople style={{ marginBottom: "5px" }} />{" "}
                  {totalLeads}
                </h3>
              </Card>
            </Col>
            <Col xs={12}>
              {/* This Week chart*/}
              <div style={{ marginTop: "10px" }}>
                <WeeklyChartBusiness />
              </div>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={4}>
          <Card
            title="Average Amount"
            extra={<PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />}
            style={{width: "100%", height: "100%"  }}
          >
            <Input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search here..."
              prefix={<SearchOutlined style={{ color: "#888" }} />}
              style={{ borderRadius: "5px", padding: "8px 12px" }}
              size={isMobile ? "small" : "middle"}
            />
            <hr style={{ color: "#5F5F5F" }} />
            <div
              style={{
                minHeight: "100px",
                maxHeight: isMobile ? 250 : 500,
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {filteredData?.length > 0 ? (
                filteredData.map((averge) => (
                  <div
                    key={averge.companyName}
                    style={{
                      border: "1px solid #ddd",
                      marginTop: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <div className="carder">
                      <Avatar
                        style={{ backgroundColor: "#ebfaed", color: "#23BA89" }}
                      >
                        {averge.companyName?.charAt(0).toUpperCase()}
                      </Avatar>
                      {/* Text Section */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                        }}
                      >
                        <span style={{ fontSize: "14px" }}>
                          {averge.companyName}
                        </span>
                        <span style={{ fontSize: "11px", color: "#888" }}>
                          Business Panel
                        </span>
                      </div>
                    </div>
                    <div className="badgeAligment">
                      <p style={{ fontSize: "13px", paddingLeft: "0px" }}>
                        Average amount spent : {getSymbol(country)}{" "}
                        {averge.highestTransaction}
                      </p>
                      {/* <div className="card3AvarageBadge">
                <HiArrowTrendingUp size={18} />
                <span>20%</span>
            </div> */}
                    </div>
                  </div>
                ))
              ) : (
                <p>No data will appaer</p>
              )}
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={20} style={{ marginTop: 20 }}>
        <Col span={24}>
          <Card title="This Week's Leads">
            <div style={{ overflowX: "auto" }}>
              <div style={{ minWidth: 900 }}>
                <LeadsTable leads={leads} mini={true} />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
const mapStateToProps = (state) => ({
  businessCard: state.businesscard.response,
  thisWeekLeadBusiness: state.thisWeekLeadBusiness.response,
});

const mapDispatchToProps = (dispatch) => ({
  getAllBusinessCards_: () => {
    dispatch(getAllBusinessCards());
  },
  getThisWeekLeads_: () => {
    dispatch(getThisWeekLeadBusiness());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeadGenerationAnalytics);

// import React, { useEffect, useState } from 'react';
// import { Row, Col, Card, Statistic, Typography } from 'antd';
// import LeadsTable from '../components/Leads/LeadsTable';
// import { connect } from 'react-redux';
// import { getAllBusinessCards } from '../store/action/business/DashboardActions';
// import { getThisWeekLeadBusiness } from '../store/action/business/LeadAction';

// const LeadGenerationAnalytics = (props) => {
//   const { Title, Text } = Typography;
//   const [totalAmt, setTotalAmt] = useState(10);
//   const [totalLeads, setTotalLeads] = useState(10);
//   const [leads, setLeads] = useState([]);

//   useEffect(() => {
//     props.getAllBusinessCards_();
//     props.getThisWeekLeads_();
//   }, []);

//   useEffect(() => {
//     setTotalAmt(props.businessCard.totalAmount);
//     setTotalLeads(props.businessCard.totalDistributedLeads);
//   }, [props.businessCard]);

//   useEffect(() => {
//     if(props.thisWeekLeadBusiness && props.thisWeekLeadBusiness.leads && props.thisWeekLeadBusiness.leads.length > 0)
//       setLeads(props.thisWeekLeadBusiness.leads);
//   }, [props.thisWeekLeadBusiness]);

//   return (
//     <div style={{ padding: 20 }}>
//       <Title level={2}>Dashboard</Title>
//       <Row gutter={20} style={{ width: '100%' }}>
//         <Col span={8}>
//           <Card
//             style={{height: '100%',backgroundColor: '#4CAF50', borderRadius: 10}}>
//             <Statistic
//               value={totalAmt}
//               prefix="$"
//               suffix="CAD"
//               style={{ color: '#fff' }}/>
//             <Text type="secondary" style={{ color: '#fff' }}>
//               Total Money Spent
//             </Text>
//           </Card>
//         </Col>
//         <Col span={8}>
//           <Card
//             style={{height: '100%',backgroundColor: '#2196F3',borderRadius: 10}}>
//             <Statistic value={totalLeads} suffix="Leads" style={{ color: '#fff' }}/>
//             <Text type="secondary" style={{ color: '#fff' }}>
//               Total Leads Generated
//             </Text>
//           </Card>
//         </Col>

//      {/* <Col span={6}>
//           <Card
//             style={{height: '100%',backgroundColor: '#9C27B0',borderRadius: 10,}}>
//             <Statistic value={2000} prefix="$" suffix="CAD" style={{color: '#fff'}}/>
//             <Text type="secondary" style={{ color: '#fff' }}>
//               Assumed Minimum Revenue
//             </Text>
//           </Card>
//         </Col> */}

//         <Col span={8}>
//           <Card style={{ height: '100%', backgroundColor: 'orange', borderRadius: 10,}}>
//             <Statistic value={5000} prefix="$" suffix="Avg Spend" style={{ color: '#fff' }}/>
//             <Text type="secondary" style={{ color: '#fff' }}>
//               Average Amount Others Spent Similar to You
//             </Text>
//           </Card>
//         </Col>
//       </Row>

//       <Row gutter={20} style={{ marginTop: 20 }}>
//         <Col span={24}>
//           <Card title="This Week's Leads" >
//             <LeadsTable leads={leads} mini={true} />
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };
// const mapStateToProps = state => ({
//   businessCard: state.businesscard.response,
//   thisWeekLeadBusiness: state.thisWeekLeadBusiness.response
// })

// const mapDispatchToProps = dispatch => ({
//   getAllBusinessCards_: ()=>{
//       dispatch(getAllBusinessCards());
//   },
//   getThisWeekLeads_: ()=>{
//     dispatch(getThisWeekLeadBusiness());
//   }
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(LeadGenerationAnalytics);
